<template>
  <div class="m-wap-return" v-if="returnUrl" @click="doReturn">
    <img src="../assets/images/icon_return.png" class="return_img">
  </div>
</template>
<script>
import { URLS } from "fire-wind-water";
export default {
  name: "Return",
  data() {
    return {
      returnUrl:''
    };
  },
  methods:{
    doReturn(){
      window.$sk.goto(decodeURIComponent(this.returnUrl));
    }
  },
  created() {
    this.returnUrl = URLS.getURL("returnUrl");
    console.log(this.returnUrl)
  },

};
</script>

<style lang="scss" scoped>
.m-wap-return{
  position: fixed;
  right: 40px;
  bottom: 200px;
  background-color: #1665D8;
  overflow: hidden;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  z-index: 1;
  .return_img{
    width: 100%;
    display: block;
  }
}

</style>